<template>
  <div class="p-4 max-w-3xl mx-auto">
    <div v-if="log">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-semibold">Usage Log</h2>
        <div>
          <button @click="onEdit" class="text-green-600">Edit</button>
          <button @click="onDelete" class="text-red-600 ml-2">Delete</button>
        </div>
      </div>

      <dl>
        <div class="mb-2">
          <dt class="font-semibold">Equipment</dt>
          <dd>{{ log.equipment?.name || getEquipmentName(log.equipment_id) }}</dd>
        </div>
        <div class="mb-2">
          <dt class="font-semibold">Date</dt>
          <dd>{{ new Date(log.log_date).toLocaleDateString() }}</dd>
        </div>
        <div class="mb-2">
          <dt class="font-semibold">Hours Used</dt>
          <dd>{{ log.hours_used ?? '-' }}</dd>
        </div>
        <div v-if="isFuelEquipment(log)" class="mb-2">
          <dt class="font-semibold">Fuel Used</dt>
          <dd>{{ log.fuel_used ?? '-' }}</dd>
        </div>
        <div class="mb-2">
          <dt class="font-semibold">Tasks Performed</dt>
          <dd>{{ log.tasks_performed ?? '-' }}</dd>
        </div>
        <div class="mb-2">
          <dt class="font-semibold">Notes</dt>
          <dd>{{ log.notes ?? '-' }}</dd>
        </div>
        <div class="mb-2">
          <dt class="font-semibold">Fuel Efficiency</dt>
          <dd>{{ log.fuel_efficiency ?? '-' }}</dd>
        </div>
        <div class="mb-2">
          <dt class="font-semibold">Created By</dt>
          <dd>{{ log.created_by ?? '-' }}</dd>
        </div>
        <div class="mb-2">
          <dt class="font-semibold">Created At</dt>
          <dd>{{ log.created_at ? new Date(log.created_at).toLocaleString() : '-' }}</dd>
        </div>
      </dl>
    </div>
    <div v-else class="text-gray-500">No usage log selected.</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useEquipmentStore } from '@/stores/equipmentStore'
import type { UsageLog } from '@/types/usage'

const props = defineProps<{ log: UsageLog }>()
const emit = defineEmits(['edit', 'delete'])

const log = computed(() => props.log)

function onEdit() {
  emit('edit', props.log.id)
}

function onDelete() {
  emit('delete', props.log.id)
}

const equipmentStore = useEquipmentStore()

function getEquipmentName(id: number) {
  const eq = equipmentStore.equipment.find((e) => e.id === id)
  if (eq) return eq.name
  equipmentStore.fetchNameIfMissing(id)
  return equipmentStore.getName(id)
}

function isFuelEquipment(l: UsageLog) {
  return !!(l.is_fuel_equipment_usage || (l.equipment && l.equipment.requires_fuel))
}
</script>
